<template>
  <div class="notifications-shell d-none d-md-block" :class="{'is-big': big, 'is-small': !big}">
    <div v-if="big" class="notifications-expanded d-flex flex-column h-100">
      <div class="notifications-header">
        <div class="notifications-title">Notificaciones</div>
        <div class="notifications-counter">{{ formatCounter(totalCount) }}</div>
      </div>

      <div class="notifications-sections flex-grow-1">
        <div class="notification-section" v-for="nivel in visibleSectionKeys" :key="nivel">
          <div class="notification-section-header">
            <div class="notification-section-title">{{ getSectionTitle(nivel) }}</div>
            <div class="notification-section-counter">{{ formatCounter(sections[nivel].total) }}</div>
          </div>

          <div class="notifications-empty text-center" v-if="sections[nivel].items.length === 0">
            <i class="fa fa-bell-slash mb-1"></i>
            <div class="small">Sin notificaciones</div>
          </div>

          <div class="notifications-list" v-else>
            <div class="notification-card" v-for="notificacion in sections[nivel].items" :key="notificacion.id">
              <div class="notification-card-top">
                <span class="notification-type">{{ notificacion.name_tipo }}</span>
                <button class="btn btn-success btn-sm notification-check-btn" @click="marcarVisto(notificacion)">
                  <i v-if="!saving" class="fa fa-check"></i>
                  <i v-else class="fa fa-spinner fa-spin"></i>
                </button>
              </div>

              <div class="notification-text" :class="!notificacion.more ? 'collapse-notificacion' : ''">
                {{ notificacion.text }}
              </div>

              <button class="btn btn-outline-light btn-sm notification-link-btn"
                      @click="detalleSolicitud(notificacion)"
                      v-if="notificacion.more && notificacion.notification_type === 'App\\Solicitud'">
                Ver solicitud
              </button>

              <div class="notification-meta">
                <span class="notification-date">{{ utils.formatFecha(notificacion.created_at, 'dd/MM/yyyy HH:mm:ss ') }}</span>
                <button class="notification-read-btn" @click="showMore(notificacion)">
                  {{ !notificacion.more ? 'Leer más' : 'Leer menos' }}
                </button>
              </div>
            </div>
          </div>

          <div class="notification-pagination" v-if="sections[nivel].pagination.last_page > 1">
            <button class="btn btn-outline-light btn-sm"
                    @click="changeSectionPage(nivel, sections[nivel].pagination.current_page - 1)"
                    :disabled="sections[nivel].pagination.current_page <= 1">
              <i class="fa fa-chevron-left"></i>
            </button>
            <span>
              {{ sections[nivel].pagination.current_page }} / {{ sections[nivel].pagination.last_page }}
            </span>
            <button class="btn btn-outline-light btn-sm"
                    @click="changeSectionPage(nivel, sections[nivel].pagination.current_page + 1)"
                    :disabled="sections[nivel].pagination.current_page >= sections[nivel].pagination.last_page">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="notifications-footer">
        <button @click="collapseNotificaciones" class="btn btn-sm btn-outline-light me-1 px-2">
          <i class="fa fa-chevron-right"></i>
        </button>
        <button class="btn btn-sm btn-light me-2" v-if="totalCount > 0"
                @click="marcarAllVisto" v-tooltip="'Marcar todas como vistas'">
          <i class="fa fa-eye"></i> Todas
        </button>
        <div class="flex-grow-1 text-end notifications-results">
          {{ totalCount + (totalCount === 0 || totalCount > 1 ? ' Resultados' : ' Resultado') }}
        </div>
      </div>
    </div>

    <div v-else class="notifications-collapsed d-flex flex-column h-100">
      <div class="notifications-collapsed-icon">
        <i class="fa fa-bell"></i>
        <span class="spinner-grow spinner-grow-sm position-absolute translate-middle bg-warning" role="status"
              aria-hidden="true" v-if="newNotificacion"></span>
      </div>

      <div class="collapsed-counters flex-grow-1 w-100">
        <div class="collapsed-counter-row">
          <span class="collapsed-counter-label">PUB</span>
          <div class="badge rounded-pill text-dark w-100"
               :class="{'bg-warning': sections.publico.total > 0, 'bg-success': sections.publico.total === 0}">
            {{ formatCounter(sections.publico.total) }}
          </div>
        </div>
        <div class="collapsed-counter-row" v-if="canViewAdminSection">
          <span class="collapsed-counter-label">ADM</span>
          <div class="badge rounded-pill text-dark w-100"
               :class="{'bg-warning': sections.admin.total > 0, 'bg-success': sections.admin.total === 0}">
            {{ formatCounter(sections.admin.total) }}
          </div>
        </div>
      </div>

      <button @click="collapseNotificaciones" class="btn btn-sm btn-outline-light px-2">
        <i class="fa fa-chevron-left"></i>
      </button>
    </div>
  </div>
</template>
<script>
import Utils from "../../code/Utils";
import TipoNotificacion from "../../code/TipoNotificacion";
import RolUsuario from "../../code/RolUsuario";
import {mapState} from "pinia/dist/pinia";
import {useUserStore} from "../../stores/user";

export default {
  name: 'Notificaciones',
  data() {
    return {
      errors: [],
      sectionKeys: ['publico', 'admin'],
      sections: {
        publico: {
          items: [],
          total: 0,
          pagination: {
            current_page: 1,
            last_page: 1
          }
        },
        admin: {
          items: [],
          total: 0,
          pagination: {
            current_page: 1,
            last_page: 1
          }
        },
      },
      filtros: {
        paginate: true,
        visto: 0,
        user_id: null,
        limit: 6,
      },
      notificacion: {
        id: null,
        more: false,
        notification_id: null,
        notification_type: null,
        text: null,
        tipo: null,
      },
      big: true,
      saving: false,
      utils: Utils,
      TipoNotificacion,
      newNotificacion: false,
    };
  },
  computed: {
    ...mapState(useUserStore, ['data']),
    canViewAdminSection() {
      const rolesConPermisoAdmin = [
        RolUsuario.ADMIN,
        RolUsuario.SUPER_ADMIN,
        RolUsuario.MESA_CONTROL,
        RolUsuario.AGENTE
      ];
      return (this.data?.roles ?? []).some(r => rolesConPermisoAdmin.includes(r));
    },
    visibleSectionKeys() {
      return this.sectionKeys.filter(nivel => nivel !== 'admin' || this.canViewAdminSection);
    },
    totalCount() {
      return this.visibleSectionKeys.reduce((acumulado, nivel) => acumulado + this.sections[nivel].total, 0);
    }
  },
  mounted() {
    this.big = localStorage.getItem('collapse.notificaciones') === 'true';
    this.configPusher();
    this.getNotificaciones();
  },
  methods: {
    configPusher() {
      if (navigator.serviceWorker) {
        navigator.serviceWorker.register('sw.js');
      }

      Notification.requestPermission();

      this.channel = this.$pusher.subscribe('kim.notificaciones.' + this.data.id);
      this.channel.bind("App\\Events\\NotificacionCreada", (data) => {
        console.debug('NotificacionCreada', data)

        if (Notification.permission === 'granted') {
          let tipo = TipoNotificacion.getAll().filter(t => t.value === data.notificacion.tipo);

          if (navigator.serviceWorker) {
            navigator.serviceWorker.ready.then(registration => {
              registration.showNotification(tipo[0]['title'], {
                body: data.notificacion.text,
                icon: '/public/favicon-edi.png'
              });
            });
          }
        }

        const nivel = this.getNivel(data.notificacion);
        if (nivel === 'admin' && !this.canViewAdminSection) {
          return;
        }
        this.sections[nivel].pagination.current_page = 1;
        this.getNotificacionesNivel(nivel, 1);
        this.newNotificacion = true;
      });
    },
    async getNotificaciones() {
      this.saving = true;
      this.filtros.user_id = this.data.id;

      try {
        await Promise.all(this.visibleSectionKeys.map(nivel => this.getNotificacionesNivel(nivel)));
      } catch (error) {
        this.errors = error?.response?.data?.errors ?? [];
      } finally {
        this.saving = false;
      }
    },
    async getNotificacionesNivel(nivel, page = null) {
      if (nivel === 'admin' && !this.canViewAdminSection) {
        return;
      }

      const section = this.sections[nivel];
      const selectedPage = page ?? section.pagination.current_page ?? 1;

      const filtros = {
        ...this.filtros,
        nivel
      };

      try {
        const res = await axios.get('api/notificaciones', {
          params: {
            page: selectedPage,
            campos: filtros,
          }
        });

        if (res.data.status === 'ok') {
          const items = res.data.data.items ?? {};

          section.items = items.data ?? [];
          section.total = res.data.data.total ?? section.items.length;
          section.pagination.current_page = items.current_page ?? selectedPage;
          section.pagination.last_page = items.last_page ?? 1;

          if (section.pagination.current_page > section.pagination.last_page && section.pagination.last_page > 0) {
            return this.getNotificacionesNivel(nivel, section.pagination.last_page);
          }
        }
      } catch (error) {
        this.errors = error?.response?.data?.errors ?? [];
      }
    },
    changeSectionPage(nivel, page) {
      const section = this.sections[nivel];
      if (page < 1 || page > section.pagination.last_page) {
        return;
      }

      section.pagination.current_page = page;
      this.getNotificacionesNivel(nivel, page);
    },
    showMore(notificacion) {
      this.notificacion = notificacion;
      this.notificacion.more = !this.notificacion.more;
    },
    marcarVisto(notificacion) {
      this.saving = true;
      this.notificacion = notificacion;
      this.notificacion.visto = true;

      axios.put('api/notificaciones/' + this.notificacion.id, this.notificacion)
          .then(res => {
            if (res.data.status === 'ok') {
              this.getNotificaciones();
              this.$emitter.emit('messages.show_success', res.data.data.message);
            } else {
              this.$emitter.emit('messages.show_error', res.data.data.message);
            }
            this.saving = false;
          }).catch(error => {
        this.saving = false;
        this.errors = error?.response?.data?.errors ?? [];
      });
    },
    detalleSolicitud(data) {
      this.$router.push("/solicitudes/view/" + data.notification_id);
    },
    collapseNotificaciones() {
      this.big = !this.big;
      this.newNotificacion = false;
      localStorage.setItem('collapse.notificaciones', this.big);
    },
    marcarAllVisto() {
      this.saving = true;

      axios.post('api/notificaciones/all_vistas')
          .then(res => {
            if (res.data.status === 'ok') {
              this.getNotificaciones();
              this.$emitter.emit('messages.show_success', res.data.data.message);
            } else {
              this.$emitter.emit('messages.show_error', res.data.data.message);
            }
            this.saving = false;
          }).catch(error => {
        this.saving = false;
        this.errors = error?.response?.data?.errors ?? [];
      });
    },
    getNivel(notificacion) {
      return notificacion?.nivel === 'admin' ? 'admin' : 'publico';
    },
    getSectionTitle(nivel) {
      return nivel === 'admin' ? 'Admin' : 'Público';
    },
    formatCounter(total) {
      return total > 99 ? '99+' : total;
    }
  }
}
</script>
<style scoped="">
.collapse-notificacion {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notifications-shell {
  background: linear-gradient(180deg, var(--tw-secondary-800) 0%, var(--tw-secondary-900) 100%);
  border-left: 1px solid rgba(255, 255, 255, 0.12);
}

.notifications-expanded {
  gap: 0.75rem;
}

.notifications-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.notifications-title {
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.notifications-counter {
  min-width: 2.1rem;
  text-align: center;
  padding: 0.2rem 0.5rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  background: var(--tw-primary-500);
  color: #ffffff;
}

.notifications-sections {
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0.2rem;
}

.notification-section {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  padding: 0.55rem;
  margin-bottom: 0.7rem;
}

.notification-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.notification-section-title {
  font-size: 0.83rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.93);
}

.notification-section-counter {
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  min-width: 1.85rem;
  padding: 0.08rem 0.45rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-align: center;
}

.notifications-list {
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0.1rem;
}

.notification-card {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.18);
  color: #ffffff;
  padding: 0.6rem;
  margin-bottom: 0.65rem;
  transition: transform 140ms ease, box-shadow 140ms ease;
}

.notification-card:last-child {
  margin-bottom: 0.15rem;
}

.notification-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.notification-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
}

.notification-type {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.1rem 0.55rem;
  font-size: 0.72rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.14);
  letter-spacing: 0.02em;
  max-width: 78%;
}

.notification-check-btn {
  min-width: 2rem;
}

.notification-text {
  font-size: 0.85rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.94);
}

.notification-link-btn {
  width: 100%;
  margin-top: 0.55rem;
}

.notification-meta {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.notification-date {
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.68);
}

.notification-read-btn {
  border: none;
  background: transparent;
  color: #ffffff;
  text-decoration: underline;
  font-size: 0.76rem;
  font-weight: 600;
  padding: 0;
}

.notification-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  margin-top: 0.4rem;
  color: rgba(255, 255, 255, 0.95);
  font-size: 0.75rem;
}

.notifications-empty {
  border: 1px dashed rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  padding: 0.6rem 0.4rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 0.2rem;
}

.notifications-empty i {
  font-size: 0.95rem;
}

.notifications-footer {
  display: flex;
  align-items: center;
  color: #ffffff;
}

.notifications-results {
  font-size: 0.8rem;
  opacity: 0.9;
}

.notifications-collapsed {
  align-items: center;
  gap: 0.75rem;
}

.notifications-collapsed-icon {
  color: #ffffff;
  font-size: 1.35rem;
  position: relative;
  margin-top: 0.15rem;
}

.collapsed-counters {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.collapsed-counter-row {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.collapsed-counter-label {
  font-size: 0.58rem;
  color: rgba(255, 255, 255, 0.85);
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.is-big {
  min-width: 310px;
  max-width: 310px;
}

.is-small {
  min-width: 72px;
  max-width: 72px;
}
</style>
